import { carouselItems } from '@/mocks/home';

const labelColors: Record<string, { bg: string; text: string }> = {
  primary: { bg: 'bg-primary-500', text: 'text-background-50' },
  accent: { bg: 'bg-accent-500', text: 'text-background-50' },
  secondary: { bg: 'bg-secondary-500', text: 'text-foreground-900' },
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            精选专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            编辑团队精心策划的影视专题，发现更多好内容
          </p>
        </div>

        <div className="flex flex-col gap-6 md:gap-8">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col md:flex-row items-stretch bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="w-full md:w-[45%] lg:w-[40%] relative overflow-hidden aspect-[16/10] md:aspect-auto">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const el = e.target as HTMLImageElement;
                    el.style.display = 'none';
                    (el.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
              <div className="flex-1 p-5 md:p-8 flex flex-col justify-center">
                <span
                  className={`self-start inline-block px-3 py-1 rounded-full text-xs font-medium mb-3 ${
                    labelColors[item.color]?.bg || 'bg-secondary-500'
                  } ${labelColors[item.color]?.text || 'text-foreground-900'}`}
                >
                  {item.label}
                </span>
                <h3 className="text-lg md:text-xl font-bold font-heading text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}